import { cn } from '@ttab/elephant-ui/utils'
import type { JSX } from 'react'

/**
 * Shared chrome for the fields that sit on the editor surface itself. The
 * border stays neutral whether or not the field has a value, `data-state`
 * still tells the two apart.
 */
export const EditorPill = ({ field, hasValue, children }: {
  field: string
  hasValue: boolean
  children: JSX.Element
}): JSX.Element => {
  return (
    <div
      data-field={field}
      data-state={hasValue ? 'set' : 'missing'}
      className={cn(
        'flex flex-row items-center gap-2 w-fit border-[1.5px] rounded-lg px-3 py-1',
        'border-gray-200 dark:border-gray-400'
      )}
    >
      {children}
    </div>
  )
}
